import { render, staticRenderFns } from "./outbound.vue?vue&type=template&id=94f7a260&scoped=true"
import script from "./outbound.vue?vue&type=script&lang=js"
export * from "./outbound.vue?vue&type=script&lang=js"
import style0 from "./outbound.vue?vue&type=style&index=0&id=94f7a260&prod&lang=scss"
import style1 from "./outbound.vue?vue&type=style&index=1&id=94f7a260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f7a260",
  null
  
)

export default component.exports